module.exports = __webpack_public_path__ + "assets/logo.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo.png
 ** module id = 219
 ** module chunks = 1
 **/